import styled from 'styled-components'

import IconButton from '../Button/IconButton'
import Image from '../Image/Container'
import Body from '../ApartmentCard/Body'

import { toRgbString } from '../../helpers'

const ApartmentCardPopup = styled.div`
  font-size: 0.8em;

  .mapboxgl-popup-content {
    padding: 0;
    width: 300px;
  }

  .mapboxgl-popup-content > ${IconButton} {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: ${props => toRgbString(props.theme.colors.black, 0.5)};
    color: ${props => props.theme.fontColorWithBackground.black};
    width: 25px;
    height: 25px;
    border: 0;
    border-radius: 50%;
    z-index: 2;

    svg {
      transform: translateY(-4%);
    }
  }

  ${Image} {
    border-radius: 0;
  }

  ${Body} {
    margin: 0;
    border: 0;
    border-radius: 0;
    width: 100%;
  }
`

export default ApartmentCardPopup
